import React from "react";
import FormPedido from "../../Components/FormPedido/FormPedido";


const PagePedido: React.FC = () => {
  return (
    <div className="d-flex flex-column container-fluid">
      <FormPedido />
    </div>
  );
};

export default PagePedido;
